import { Injectable, inject } from '@angular/core';

import { OnAppInit } from '../bootstrap/bootstrapper.service';
import { NavigationService } from './navigation.service';

@Injectable()
export class NavigationBootstrapService implements OnAppInit {
    private readonly navigationService = inject(NavigationService);

    onAppInit() {
        this.navigationService.init();
    }
}
